import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';

import { DbQuestionChangeLogItem } from '~src/types/db';
import { QueryKeys } from './queryKeys';
import {
  getQuestionsChangeLogList,
  GetQuestionsChangeLogListParams,
} from '~src/services/api/questions';

export const useQuestionsChangeLog = (
  params: GetQuestionsChangeLogListParams,
  queryConfig: QueryConfig<DbQuestionChangeLogItem[], AxiosError> = {}
) => {
  const { enabled, ...options } = queryConfig;

  const enabledOverride = enabled || enabled === undefined;

  const filesQuery = useQuery(
    [QueryKeys.question, params],
    (key, params: GetQuestionsChangeLogListParams) =>
      getQuestionsChangeLogList(params),
    {
      enabled: enabledOverride,
      ...options,
    }
  );

  return filesQuery;
};
